export enum sectionTypes {
  SEPARATOR = 'Separator',
  CONTENT = 'Content',
}
